import Frame from "../common/Frame";
import React from "react";
import Footer from "../common/Footer";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {useTranslation} from "react-i18next";
import './ThankYouPageInvitation.css';
import {registerConcersion} from "../../logic/funel/FacebookUtils";


export function ThankYouPageInvitation() {
    const { t } = useTranslation();
    registerConcersion('Purchase');
    return (
        <div>
            <Frame>
                <h2 className="offer-pay__title">
                    {t("YouRegistrationOKThankYou!")}
                </h2>
                <br/>
                <h2 className="app-title">{t("ISendInvitationInstruktionsToEmail!")}</h2>
                <h2 className="app-title">{appdata.customerEmail}</h2>
                <br/>
                <h2 className="app-title">{t("SeeYouOnConcert!")}</h2>
                <Footer></Footer>
                <input name="leadId" value={appdata.leadId} className="leadId"/>
            </Frame>
        </div>
    );
}

